import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Alert
} from "@mui/material";
import { Warning } from "@mui/icons-material";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { toggleHumanaReferralWarningDialog } from "../../../../../app/slices/VerificationModuleSlice";

function HumanaReferralWarningDialog() {
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(
    (state) => state.verificationModule.HumanaReferralWarningDialog
  );

  const handleClose = () => {
    dispatch(toggleHumanaReferralWarningDialog());
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Warning color="error" />
        Referral Number Required
      </DialogTitle>

      <DialogContent>
        <Alert severity="error" sx={{ mb: 2 }}>
          <DialogContentText component="div">
            <strong>Humana & Humana Medicare Requirement</strong>
            <br />A referral number is required for all Humana and Humana
            Medicare cases.
          </DialogContentText>
        </Alert>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} variant="contained" color="primary">
          Understood
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export { HumanaReferralWarningDialog };
